import React from 'react';
import { DNAButton, DNAContextMenu } from '@alucio/lux-ui';
import { TitleBarEllipsisMenuProps } from './TitleBar.types';
import { useAppSettings } from 'src/state/context/AppSettings';

interface TitleBarEllipsisMenuComponentProps {
  ellipsisMenu: TitleBarEllipsisMenuProps;
}

const TitleBarEllipsisMenu: React.FC<TitleBarEllipsisMenuComponentProps> = ({ ellipsisMenu }) => {
  const { deviceMode } = useAppSettings();
  const isTablet = deviceMode === 'tablet';

  if (ellipsisMenu.items.length === 0) {
    return null;
  }

  return (
    <DNAContextMenu>
      <DNAContextMenu.Anchor>
        <DNAButton
          appearance="outline"
          status="tertiary"
          size={isTablet ? 'xl' : 'md'}
          iconLeft="dots-three-vertical-bold"
        />
      </DNAContextMenu.Anchor>
      <DNAContextMenu.Items>
        {ellipsisMenu.items.map((item) => (
          <DNAContextMenu.Item
            key={item.label.replace(/\s+/g, '').toLowerCase()}
            title={item.label}
            icon={item.icon}
            onPress={() => {
              if (!item.disabled) {
                item.onPress();
              }
            }}
            status={item.disabled ? 'subtle' : 'neutral'}
          />
        ))}
      </DNAContextMenu.Items>
    </DNAContextMenu>
  );
};

export default TitleBarEllipsisMenu;
